import { Box, Button, Group, Text } from '@mantine/core';
import { IconCookie } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'lft.cookie_ok';

export function CookieBanner() {
  const { t } = useTranslation('common');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(window.localStorage.getItem(STORAGE_KEY) !== 'true');
  }, []);

  if (!visible) return null;

  const accept = () => {
    window.localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  return (
    <Box
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        right: 16,
        bottom: 16,
        maxWidth: 480,
        zIndex: 1000,
        background: '#fff',
        border: '1px solid #e8e8e8',
        borderLeft: '4px solid #37B6BD',
        boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
        borderRadius: 4,
        padding: 12,
      }}
    >
      <Group gap="sm" wrap="nowrap" align="flex-start">
        <IconCookie size={20} color="#37B6BD" style={{ marginTop: 2, flexShrink: 0 }} />
        <Box style={{ flex: 1 }}>
          <Text size="sm">
            {t('cookie.notice')}{' '}
            <Link to="/datenschutz" style={{ color: '#37B6BD' }}>
              {t('cookie.linkText')}
            </Link>
          </Text>
        </Box>
        <Button size="xs" onClick={accept} variant="filled" color="lag">
          {t('cookie.accept')}
        </Button>
      </Group>
    </Box>
  );
}
